{
  "ar": {
    "tamin": "التأمين الاجتماعي",
    "salamat": "التأمين الصحي (سلامت)",
    "armed": "تأمين القوات المسلحة",
    "azad": "دفع ذاتي",
    "dana": "تأمين دانا",
    "asia": "تأمين آسيا",
    "alborz": "تأمين البرز",
    "parsian": "تأمين بارسيان",
    "moalem": "تأمين المعلم",
    "kowsar": "تأمين كوثر",
    "ma": "تأمين ما",
    "sina": "تأمين سينا",
    "razi": "تأمين رازي"
  }
}
